import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, FormControl, MenuItem, Select, Button, Radio, RadioGroup, FormControlLabel, FormLabel, Alert, Snackbar  } from '@mui/material'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios'
import DaumPostcode from 'react-daum-postcode';
import { useLocation, useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';

const useStyles = makeStyles((theme)=>({
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  memberEditBlockH1:{
    padding:'40px 0 20px 10px',
    fontWeight:'700',
    fontSize:'22px',
  },
  innerDiv:{
    padding:'20px 10px',
    display:'flex',
    alignItems:'center',
    borderBottom:'1px solid #e2e2e2',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'250px',
    marginRight:'10px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center'
    }
  },
  addressBtn:{
    width:'100px',
    height:'59px',
    marginRight:'10px',

    [theme.breakpoints.down(1025)]: {
      marginRight:'0',
      margin:'0px 0 20px 0'
    },
  },
  openPostcodeTextFieldDiv:{
    padding:'10px 0'
  },
  memberEditLiReactQuill:{
    display:'flex',    
    padding:'0px 0 40px 10px',
    height:'400px',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      
    },
  },
  reactQuill:{
    width:'800px',
    height:'300px',

    [theme.breakpoints.down(1025)]: {
      width:'100%',
      height:'270px'
      
    },
  },
  itemaddTextarea:{
    width:'800px',
    height:'300px',
    border:'1px solid #ccc',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  inputDiv:{
    [theme.breakpoints.down(1025)]: {
      padding:'10px 0 20px 80px '
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px',
    paddingBottom:'30px'
  },
  btnButton:{
    margin:'0 0 0 40px'
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },

}));


const MemberEdit = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const location = useLocation();
  let navigate = useNavigate();
  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);
  const [openPostcode, setOpenPostcode] = useState(false);

  const [mbNo, setMbNo] = useState('');
  const [mbId, setMbId] = useState('');
  const [mbPassword, setMbPassword] = useState('');
  const [mbName, setMbName] = useState('');
  const [mbNick, setMbNick] = useState('');
  const [mbLevel, setMbLevel] = useState(0);
  const [mbPoint, setMbPoint] = useState(0);
  const [mbEmail, setMbEmail] = useState('');
  const [mbHomepage, setMbHomepage] = useState('');
  const [mbHp, setMbHp] = useState('');
  const [mbTel, setMbTel] = useState('');
  const [mbZip1, setMbZip1] = useState('');
  const [mbZip2, setMbZip2] = useState('');
  const [mbAddr1, setMbAddr1] = useState('');
  const [mbAddr2, setMbAddr2] = useState('');
  const [mbAddr3, setMbAddr3] = useState('');
  const [mbMailling, setMbMailling] = useState(0);
  const [mbSms, setMbSms] = useState(0);
  const [mbMemo, setMbMemo] = useState('');
  const [mbDatetime, setMbDatetime] = useState('');
  const [mbTodayLogin, setMbTodayLogin] = useState('');
  const [mbIp, setMbIp] = useState('');
  const [mbLeaveDate, setMbLeaveDate] = useState('');
  const [mbInterceptDate, setMbInterceptDate] = useState('');
  const [mbRegion, setMbRegion] = useState('');
  const [mbStorename, setMbStorename] = useState('');
  const [picId, setPicId] = useState(1);
  const [mbBizPaper, setMbBizPaper] = useState('');
  const [mbBizNo, setMbBizNo] = useState('');
  const [mbBizName, setMbBizName] = useState('');
  const [mbBizTaxMail, setMbBizTaxMail] = useState('');

  const [picList, setPicList] = useState([])

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setOpenPostcode(false)
      setMbNo('')
      setMbId('')
      setMbPassword('')
      setMbName('')
      setMbNick('')
      setMbLevel(0)
      setMbPoint(0)
      setMbEmail('')
      setMbHomepage('')
      setMbHp('')
      setMbTel('')
      setMbZip1('')
      setMbZip2('')
      setMbAddr1('')
      setMbAddr2('')
      setMbAddr3('')
      setMbMailling(0)
      setMbSms(0)
      setMbMemo('')
      setMbDatetime('')
      setMbTodayLogin('')
      setMbIp('')
      setMbLeaveDate('')
      setMbInterceptDate('')
      setMbRegion('')
      setMbStorename('')
      setPicId(1)
      setMbBizPaper('')
      setMbBizNo('')
      setMbBizName('')
      setMbBizTaxMail('')
      setPicList([])
    }
  }, [])


  const getItem = async() => {
    try {
      setLoading(true)
      const res = await axios.post('/api/adm/memberEditPageView/', {mb_no: location.state.mb_no} )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
      }else{
        const result = res.data.result

        setMbNo(result['mb_no'])
        setMbId(result['mb_id'])
        setMbName(result['mb_name'])
        setMbNick(result['mb_nick'])
        setMbLevel(result['mb_level'])
        setMbPoint(result['mb_point'])
        setMbEmail(result['mb_email'])
        setMbHomepage(result['mb_homepage'])
        setMbHp(result['mb_hp'])
        setMbTel(result['mb_tel'])
        setMbZip1(result['mb_zip1'])
        setMbZip2(result['mb_zip2'])
        setMbAddr1(result['mb_addr1'])
        setMbAddr2(result['mb_addr2'])
        setMbAddr3(result['mb_addr3'])
        setMbMailling(result['mb_mailling'])
        setMbSms(result['mb_sms'])
        setMbMemo(result['mb_memo'])
        setMbDatetime(result['mb_datetime'])
        setMbTodayLogin(result['mb_today_login'])
        setMbIp(result['mb_ip'])
        setMbLeaveDate(result['mb_leave_date'])
        setMbInterceptDate(result['mb_intercept_date'])
        setMbRegion(result['mb_region'])
        setMbStorename(result['mb_storename'])
        setPicId(result['pic_id'])
        setMbBizPaper(result['mb_biz_paper'])
        setMbBizNo(result['mb_biz_no'])
        setMbBizName(result['mb_biz_name'])
        setMbBizTaxMail(result['mb_biz_tax_mail'])

        setPicList(res.data.picList)
        setLoading(false)
      }
      
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }

  useEffect(() => {
    if(location.state.mb_no){
      getItem()
    }
  } , [location.state.mb_no])




  const editItem = async() => {
    let formData = new FormData()

    formData.append("mb_no", mbNo)
    formData.append("mb_password", mbPassword)
    formData.append("mb_name", mbName)
    formData.append("mb_nick", mbNick)
    formData.append("mb_level", mbLevel)
    formData.append("mb_email", mbEmail)
    formData.append("mb_homepage", mbHomepage)
    formData.append("mb_hp", mbHp)
    formData.append("mb_tel", mbTel)
    formData.append("mb_zip1", mbZip1)
    formData.append("mb_zip2", mbZip2)
    formData.append("mb_addr1", mbAddr1)
    formData.append("mb_addr2", mbAddr2)
    formData.append("mb_addr3", mbAddr3)
    formData.append("mb_mailling", mbMailling)
    formData.append("mb_sms", mbSms)
    formData.append("mb_memo", mbMemo)
    formData.append("mb_leave_date", mbLeaveDate)
    formData.append("mb_intercept_date", mbInterceptDate)
    formData.append("mb_region", mbRegion)
    formData.append("mb_storename", mbStorename)
    formData.append("pic_id", picId)
    formData.append("mb_biz_no", mbBizNo)
    formData.append("mb_biz_name", mbBizName)
    formData.append("mb_biz_tax_mail", mbBizTaxMail)
    formData.append("mb_biz_paper", mbBizPaper)

    try {
      const res = await axios.post(
        '/api/adm/memberEditView/',
                            formData, 
                            {
                              headers: {
                                'Content-Type': 'multipart/form-data'
                              }
                            }
    )

      if(res.data.success === false) {
        setErrSnack(true)
      }
        setSuccSnack(true)
        getItem()
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }

  }

  const fileDown = async() => {
    try {
      const res = await axios.post(
        '/api/adm/memberFileDownload/',
        {mb_biz_paper: mbBizPaper},
        {
          responseType: 'blob',
        }
        )

      setSuccSnack(true)

      const name = res.headers["content-disposition"].split("filename=")[1].replace(/"/g, "");
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", name);
      link.style.cssText = "display:none";
      document.body.appendChild(link);
      link.click();
      link.remove();


    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }



  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.memberEditBlock}>
      {loading ? (
        <div className={classes.load}>
          <TbLoader className={classes.loadingIcon}/>
        </div>
      ) : (
        <>
        <div className={classes.box}>
        <h1 className={classes.memberEditBlockH1}>회원수정</h1>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>아이디</span>
          <TextField  
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbId}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>이름</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbName}
            onChange={(e) => {setMbName(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>비밀번호</span>
          <TextField  
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbPassword}
            onChange={(e) => {setMbPassword(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>닉네임</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbNick}
            onChange={(e) => {setMbNick(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>회원권한</span>
          <FormControl>
            <Select
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              value={mbLevel}
              onChange={(e) => {setMbLevel(e.target.value)}}
              style={{ width:'250px' }}
            >
              <MenuItem value={0}>0</MenuItem>
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={6}>6</MenuItem>
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={8}>8</MenuItem>
              <MenuItem value={9}>9</MenuItem>
              <MenuItem value={10}>10</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>포인트</span>
          {mbPoint}
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>e-mail</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbEmail}
            onChange={(e) => {setMbEmail(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>홈페이지</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbHomepage}
            onChange={(e) => {setMbHomepage(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>휴대폰번호</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbHp}
            onChange={(e) => {setMbHp(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>전화번호</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbTel}
            onChange={(e) => {setMbTel(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>주소</span>
          <button 
            onClick={() => setOpenPostcode(!openPostcode)}
            className={classes.addressBtn}
          >
            주소검색
          </button>
            {openPostcode && 
              <DaumPostcode 
                  onComplete={(data) => {
                    let zip1 = data.zonecode.substr(0, 3);
                    let zip2 = data.zonecode.substr(3, 3);
                    let addr1 = data.address
    
                    setMbZip1(zip1)
                    setMbZip2(zip2)
                    setMbAddr1(addr1)
                    setOpenPostcode(false);
                  }}
                  autoClose={false} 
            />}
          <div className={classes.openPostcodeTextFieldDiv}>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              InputProps={{
                readOnly: true,
              }}   
              value={mbZip1+mbZip2}
            />
          </div>
          <div className={classes.openPostcodeTextFieldDiv}>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              InputProps={{
                readOnly: true,
              }}   
              value={mbAddr1}
            />
          </div>
          <div className={classes.openPostcodeTextFieldDiv}>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              value={mbAddr2}
              onChange={(e) => {setMbAddr2(e.target.value)}}
            />
          </div>
          <div className={classes.openPostcodeTextFieldDiv}>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              value={mbAddr3}
              onChange={(e) => {setMbAddr3(e.target.value)}}
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          
          <FormControl>
            <FormLabel>메일수신</FormLabel>
            <RadioGroup 
              value={mbMailling} 
              onChange={(e) => {setMbMailling(e.target.value)}} 
              row
            >
              <FormControlLabel value={0} control={<Radio />} label="아니오" />
              <FormControlLabel value={1} control={<Radio />} label="예" />
            </RadioGroup>
          </FormControl>
        </div>
        <div className={classes.innerDiv}>
          
          <FormControl>
            <FormLabel>SMS수신</FormLabel>
            <RadioGroup 
              value={mbSms} 
              onChange={(e) => {setMbSms(e.target.value)}} 
              row
            >
              <FormControlLabel value={0} control={<Radio />} label="아니오" />
              <FormControlLabel value={1} control={<Radio />} label="예" />
            </RadioGroup>
          </FormControl>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>메모</span>
          <ReactQuill 
            theme="snow" 
            value={mbMemo}
            onChange={(content, delta, source, editor) => {setMbMemo(editor.getHTML())}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>회원가입일</span>
          {mbDatetime}
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>최근접속일</span>
          {mbTodayLogin}
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>IP</span>
          {mbIp}
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>탈퇴일자</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbLeaveDate}
            onChange={(e) => {setMbLeaveDate(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>접근차단일자</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbInterceptDate}
            onChange={(e) => {setMbInterceptDate(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>지역</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbRegion}
            onChange={(e) => {setMbRegion(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>상호명</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbStorename}
            onChange={(e) => {setMbStorename(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>관리자</span>
          <FormControl 
            size="small"
          >
            <Select
              value={picId}
              onChange={(e) => {setPicId(e.target.value)}}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              style={{ width:'250px' }}
            >
              {picList.length > 0 &&
                  picList.map((item) => (
                    <MenuItem key={item['pic_id']} value={item['pic_id']}>{item['pic_name']}</MenuItem>
                  ))
              }
            </Select>
          </FormControl>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>사업자등록증</span>
          {typeof(mbBizPaper) === 'string' ? mbBizPaper : mbBizPaper.name}
          <div className={classes.inputDiv}>
            <input 
              type="file" 
              accept=".gif, .jpg, .jpeg, .png, .pdf"
              onChange={(e) => {
                setMbBizPaper(e.target.files[0])
              }}
            />
          </div>
          <Button     
            variant="outlined"
            onClick={() => {setMbBizPaper('')}}
            style={{ margin:'10px'}}
          >
            사업자 등록증 삭제
          </Button>
          {(typeof(mbBizPaper) === 'string' && mbBizPaper.length > 0) && (
              <Button        
                variant="outlined"
                onClick={() => fileDown()}
                style={{ margin:'10px'}}
              >
                파일 다운로드
              </Button>
          )}
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>사업자등록번호</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbBizNo}
            onChange={(e) => {
              setMbBizNo(e.target.value)
            }}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>대표자성명</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbBizName}
            onChange={(e) => {setMbBizName(e.target.value)}}
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>세금계산서 메일</span>
          <TextField 
            style={{ width:'250px' }}
            hiddenlabel="true" 
            variant="outlined" 
            value={mbBizTaxMail}
            onChange={(e) => {setMbBizTaxMail(e.target.value)}}
          />
        </div>
  
  
  
  
        <div className={classes.btnDiv}> 
          <div>
            <Button 
              variant="outlined"
              onClick={()=> editItem()}
            >
              확인
            </Button>
          </div>
          <div className={classes.btnButton}>
            <Button 
              variant="outlined"
              onClick={() => {
                navigate("/DashboardMain/memberConfig");
              }}
            >
              목록
            </Button>
          </div>
        </div>

      </div>
      





      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
      </>
      )}

    </div>
  )
}

export default MemberEdit
